import { LAYER_TYPE } from '../layer'
import { ALayer } from './ALayer'
import { NbdsRasterLayer } from './NbdsRasterLayer'
import { NbdsVectorLayer } from './NbdsVectorLayer'

export function LayerDataCreate(type, layer) {
  switch (type) {
    case LAYER_TYPE.NBDS_VECTO_LAYER:
      if (layer.data_type === 'pdf') {
        return new NbdsRasterLayer(layer)
      }
      return new NbdsVectorLayer(layer)
    default:
      return new ALayer(layer)
  }
}
